import React from 'react';
import { CERTIFIED_BADGE_TEXT } from '../../data/credibility.mjs';
import './credibility.css';

/**
 * Badge propio "Emisor Electrónico certificado ante la DGII".
 * No usa el logo de la DGII (organismo del Estado): iconografía y tipografía propias.
 * variant: 'light' (fondo blanco) | 'dark' (sobre fondos oscuros); size: 'md' | 'sm'
 */
const CertifiedBadge = ({ variant = 'light', size = 'md', className = '' }) => (
    <span
        className={`certified-badge${variant === 'dark' ? ' certified-badge--dark' : ''}${size === 'sm' ? ' certified-badge--sm' : ''} ${className}`.trim()}
        title={CERTIFIED_BADGE_TEXT}
    >
        <span className="certified-badge__icon" aria-hidden="true">
            <i className="fas fa-check"></i>
        </span>
        <span>{CERTIFIED_BADGE_TEXT}</span>
    </span>
);

export default CertifiedBadge;
